/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Modal } from 'antd';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';

export type PauseBannersModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function PauseBannersModal({ open, onConfirm, onCancel }: PauseBannersModalProps) {
  const { t } = useMimicTranslation('jobs');

  return (
    <Modal
      title={t('pauseBannersModal.title')}
      centered
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText={t('pauseBannersModal.confirm')}
      cancelText={t('pauseBannersModal.cancel')}
    >
      {t('pauseBannersModal.description')}
    </Modal>
  );
}
